(() => {
  if (window.__diasharkBulkDiscountSelectorLoaded) return;
  window.__diasharkBulkDiscountSelectorLoaded = true;

  const getHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || window.Shopify?.currency?.shopCurrency || 'USD';

    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    } catch {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const getProductData = async () => {
    const handle = getHandle();
    if (!handle) return null;

    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) return null;
    return response.json();
  };

  const findProductInfo = () => document.querySelector('product-info');
  const findQuantityInput = (root) =>
    root.querySelector('.product-form__quantity .quantity__input, quantity-input .quantity__input, input[name="quantity"]');
  const findVariantInput = (root) => root.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');

  const setQuantity = (input, quantity) => {
    if (!input || Number(input.value) === quantity) return;
    input.value = String(quantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const getSelectedTierQuantity = (quantity) => {
    if (quantity >= 5) return 5;
    if (quantity >= 2) return 2;
    return 1;
  };

  const getCurrentVariant = (root, product) => {
    const variantId = Number(findVariantInput(root)?.value);
    return product.variants.find((variant) => Number(variant.id) === variantId) || product.variants.find((variant) => variant.available) || product.variants[0];
  };

  const initForProductInfo = async (root) => {
    if (!root) return;

    const quantityInput = findQuantityInput(root);
    const module = root.querySelector('.diashark-bulk-discount:not([data-bulk-discount-ready="true"])');

    if (!quantityInput || !module) return;

    let product;
    try {
      product = await getProductData();
    } catch {
      return;
    }

    if (!product) return;

    module.dataset.bulkDiscountReady = 'true';

    const updateSelectedOption = () => {
      const selectedQuantity = getSelectedTierQuantity(Number(quantityInput.value) || 1);
      module.querySelectorAll('.diashark-bulk-discount__option').forEach((option) => {
        option.setAttribute('aria-pressed', option.dataset.quantity === String(selectedQuantity) ? 'true' : 'false');
      });
    };

    const updatePrices = () => {
      const variant = getCurrentVariant(root, product);
      if (!variant) return;

      module.querySelectorAll('.diashark-bulk-discount__option').forEach((option) => {
        const discount = Number(option.dataset.discount) || 0;
        const quantity = Number(option.dataset.quantity) || 1;
        const discountedUnitPrice = Math.round((Number(variant.price) * (100 - discount)) / 100);
        const suffix = quantity === 1 ? '' : '/pack';
        option.querySelector('.diashark-bulk-discount__price').textContent = `${formatMoney(discountedUnitPrice)}${suffix}`;
      });
    };

    module.addEventListener('click', (event) => {
      const option = event.target.closest('.diashark-bulk-discount__option');
      if (!option) return;
      setQuantity(quantityInput, Number(option.dataset.quantity));
      updateSelectedOption();
    });

    quantityInput.addEventListener('input', updateSelectedOption);
    quantityInput.addEventListener('change', updateSelectedOption);
    root.addEventListener('change', (event) => {
      if (event.target?.name === 'id') window.setTimeout(updatePrices);
    });

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(updatePrices));
    }

    updatePrices();
    updateSelectedOption();
  };

  const init = () => {
    if (!/\/products\//.test(window.location.pathname)) return;
    initForProductInfo(findProductInfo());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', (event) => initForProductInfo(event.target));
})();
